import { Globe } from "lucide-react";
import type { UserInfo } from "../types";

interface UserInfoProps {
  userInfo: UserInfo | null;
}

export function UserInfo({ userInfo }: UserInfoProps) {
  return (
    <div className="flex items-center space-x-4 p-6 bg-white rounded-lg shadow-lg">
      {userInfo ? (
        <>
          <div className="flex-shrink-0">
            <Globe className="h-12 w-12 text-blue-500" />
          </div>
          <div className="flex-grow">
            <h3 className="text-lg font-semibold text-gray-900">Kết nối</h3>
            <div className="mt-1 text-sm text-gray-500">
              <p>
                <span className="select-all border-1 border-gray-3 p-0.5 rounded-md">
                  {userInfo.ip}
                </span>
                <span className="font-semibold">{" ← click & copy"}</span>
              </p>
              {userInfo.city && userInfo.country && (
                <p>
                  Location: {userInfo.city}, {userInfo.country}
                </p>
              )}
              {userInfo.isp && <p>ISP: {userInfo.isp}</p>}
              {userInfo.error && (
                <p className="text-red-500 mt-1">{userInfo.error}</p>
              )}
            </div>
          </div>
          {userInfo.provider && (
            <div className="text-xs text-gray-400 self-end">
              {userInfo.provider}
            </div>
          )}
        </>
      ) : (
        <div className="animate-pulse flex space-x-4 items-center w-full">
          <div className="rounded-full bg-gray-200 h-12 w-12"></div>
          <div className="flex-1 space-y-4 py-1">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
